import * as React from 'react';
import { Route } from 'react-router-dom';
import PasswordResetPage from './password-reset';

const passwordResetUrl = (token) => `/auth/password-reset/${token}`;

const customRoutes = [
    <Route exact path={passwordResetUrl(':token')} render={() => <PasswordResetPage />} noLayout />,
];

export { customRoutes, passwordResetUrl };
